import type { ChangeEvent } from 'react'
import type { InputProps } from '@mote/ui'
import { Input } from '@mote/ui'
import { useOnboarding } from '../context'
import type { Choice, QuestionValues } from '../typings'

export interface InputAnswerProps extends Pick<Choice, 'text'> {
  surveyKey: QuestionValues['key']
  question: QuestionValues['question']
  placeholder: InputProps['placeholder']
}

export const InputAnswer = ({
  question,
  surveyKey: key,
  text,
  placeholder
}: InputAnswerProps) => {
  const { state, updateState } = useOnboarding()

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const {
      target: { value }
    } = event
    const survey = state.survey
    survey[key] = { question: question, label: text, value: value }

    updateState({ survey })
  }

  return <Input size='lg' placeholder={placeholder} onChange={handleChange} />
}
